import React, { useState } from 'react';

import FileList from './partes/FileList';
import Modal from './partes/Modal';
import ImagePreviewModal from './partes/ImagePreviewModal';
import './GestorDeArchivos.scss';
import { useFileManager } from '../../../utilidades/customHooks/useFileManager';
import useGetDataUser from '../../../utilidades/customHooks/useGetDataUser';
const urlApi = process.env.REACT_APP_API_KEY
function GestorDeArchivos() {
    const {
        files,
        loading,
        error,
        currentPath,
        fetchFiles,
        handleCreateFile,
        handleCreateFolder,
        handleRenameItem,
        handleDeleteItem,
        navigateToFolder
    } = useFileManager();

    // Estados para los modales
    const dataUser = useGetDataUser()
    const [isCreateFileModalOpen, setCreateFileModalOpen] = useState(false);
    const [isCreateFolderModalOpen, setCreateFolderModalOpen] = useState(false);
    const [isRenameModalOpen, setRenameModalOpen] = useState(false);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [fileToUpload, setFileToUpload] = useState(null);
    const [newFolderName, setNewFolderName] = useState('');
    const [itemToRename, setItemToRename] = useState('');
    const [newItemName, setNewItemName] = useState('');
    const [itemToDelete, setItemToDelete] = useState('');
    const [feedbackMessage, setFeedbackMessage] = useState(''); // Para mensajes de éxito/error

    // Estados para previsualización de imágenes
    const [isImagePreviewModalOpen, setImagePreviewModalOpen] = useState(false);
    const [imageSrcToPreview, setImageSrcToPreview] = useState('');

    // Estado para el buscador
    const [searchTerm, setSearchTerm] = useState('');

    // Handlers para abrir/cerrar modales
    const openCreateFileModal = () => { setCreateFileModalOpen(true); setFeedbackMessage(''); };
    const closeCreateFileModal = () => { setCreateFileModalOpen(false); setFileToUpload(null); setFeedbackMessage(''); };
    const openCreateFolderModal = () => { setCreateFolderModalOpen(true); setFeedbackMessage(''); };
    const closeCreateFolderModal = () => { setCreateFolderModalOpen(false); setNewFolderName(''); setFeedbackMessage(''); };
    const openRenameModal = (name) => { setItemToRename(name); setNewItemName(name); setRenameModalOpen(true); setFeedbackMessage(''); };
    const closeRenameModal = () => { setRenameModalOpen(false); setItemToRename(''); setNewItemName(''); setFeedbackMessage(''); };
    const openDeleteModal = (name) => { setItemToDelete(name); setDeleteModalOpen(true); setFeedbackMessage(''); };
    const closeDeleteModal = () => { setDeleteModalOpen(false); setItemToDelete(''); setFeedbackMessage(''); };

    // Handlers para previsualización y descarga
    const handlePreviewImage = (filePath) => {
        // Asumiendo que el backend sirve archivos estáticos en /files
        const imageUrl = `${urlApi}/files/${filePath}`;
        setImageSrcToPreview(imageUrl);
        setImagePreviewModalOpen(true);
    };

    const handleCloseImagePreviewModal = () => {
        setImagePreviewModalOpen(false);
        setImageSrcToPreview('');
    };

    const handleDownloadFile = (filePath, fileName) => {
        const fileUrl = `${urlApi}/api/files/download?path=${encodeURIComponent(filePath)}&id_user:${dataUser.user.ID}`;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName; // Esto solo es una sugerencia al navegador
        link.rel = 'noopener noreferrer';

        // 🔥 Importante: No uses `target="_blank"` aquí. Solo click simulado
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    // Funciones de Submit de formularios
    const onCreateFileSubmit = async (e) => {
        e.preventDefault();
        if (!fileToUpload) {
            setFeedbackMessage('Por favor, selecciona un archivo.');
            return;
        }
        const result = await handleCreateFile(fileToUpload);
        if (result.success) {
            setFeedbackMessage('Archivo subido con éxito.');
            closeCreateFileModal();
        } else {
            setFeedbackMessage(`Error: ${result.message}`); // Muestra el mensaje de error del backend
        }
    };

    const onCreateFolderSubmit = async (e) => {
        e.preventDefault();
        if (!newFolderName.trim()) {
            setFeedbackMessage('El nombre de la carpeta no puede estar vacío.');
            return;
        }
        const result = await handleCreateFolder(newFolderName.trim());
        if (result.success) {
            setFeedbackMessage('Carpeta creada con éxito.');
            closeCreateFolderModal();
        } else {
            setFeedbackMessage(`Error: ${result.message}`);
        }
    };

    const onRenameSubmit = async (e) => {
        e.preventDefault();
        if (!newItemName.trim()) {
            setFeedbackMessage('El nuevo nombre no puede estar vacío.');
            return;
        }
        const result = await handleRenameItem(itemToRename, newItemName.trim());
        if (result.success) {
            setFeedbackMessage('Elemento renombrado con éxito.');
            closeRenameModal();
        } else {
            setFeedbackMessage(`Error: ${result.message}`);
        }
    };

    const onDeleteConfirm = async () => {
        const result = await handleDeleteItem(itemToDelete);
        if (result.success) {
            setFeedbackMessage('Elemento eliminado con éxito.');
            closeDeleteModal();
        } else {
            setFeedbackMessage(`Error: ${result.message}`);
        }
    };

    // Lógica de filtrado para el buscador
    const filteredFiles = files.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="App">
            {/* <h1>Gestor de Archivos</h1> */}
            <div className="current-path-display">
                Ruta Actual: {currentPath === '' ? 'Home' : currentPath}
            </div>

            <div className="toolbar">
                <button onClick={openCreateFileModal}>Subir Archivo</button>
                <button onClick={openCreateFolderModal}>Crear Carpeta</button>
                <button onClick={fetchFiles}>Actualizar</button>
                {/* Input para el buscador */}
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Buscar archivos y carpetas..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>



            {loading && <p className="loading-message">Cargando archivos...</p>}
            {error && <p className="error-message">Error general al cargar: {error.message}</p>}

            {/* Mensajes condicionales para el buscador */}
            {!loading && !error && filteredFiles.length === 0 && searchTerm === '' && <p className="no-files-message">No hay archivos ni carpetas en esta ubicación.</p>}
            {!loading && !error && filteredFiles.length === 0 && searchTerm !== '' && <p className="no-files-message">No se encontraron resultados para "{searchTerm}".</p>}


            {!loading && !error && filteredFiles.length > 0 && (
                <FileList
                    files={filteredFiles} // Pasa la lista de archivos filtrados
                    onRenameClick={openRenameModal}
                    onNavigate={navigateToFolder}
                    onDeleteClick={openDeleteModal}
                    onPreviewImage={handlePreviewImage}
                    onDownloadFile={handleDownloadFile}
                />
            )}

            {/* Modales */}
            <Modal isOpen={isCreateFileModalOpen} onClose={closeCreateFileModal} title="Subir Archivo">
                <form onSubmit={onCreateFileSubmit} className="modal-form">
                    <input
                        type="file"
                        onChange={(e) => setFileToUpload(e.target.files[0])}
                        className="file-input"
                        // Atributo accept con los tipos MIME permitidos
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.odt,.ods,.odp,image/jpeg,image/png,image/gif,image/bmp,image/svg+xml,image/webp,image/tiff,text/csv,application/json,application/xml,text/xml,application/zip,application/x-rar-compressed,application/x-7z-compressed,application/x-tar,application/gzip,audio/mpeg,audio/wav,audio/ogg,audio/aac,video/mp4,video/webm,video/quicktime,video/x-msvideo,video/x-matroska"
                    />
                    <button type="submit">Subir</button>
                    {feedbackMessage && <p className={feedbackMessage.startsWith('Error') ? 'feedback-message error' : 'feedback-message success'}>{feedbackMessage}</p>}
                </form>
            </Modal>

            <Modal isOpen={isCreateFolderModalOpen} onClose={closeCreateFolderModal} title="Crear Carpeta">
                <form onSubmit={onCreateFolderSubmit} className="modal-form">
                    <input
                        type="text"
                        value={newFolderName}
                        onChange={(e) => setNewFolderName(e.target.value)}
                        placeholder="Nombre de la nueva carpeta"
                        className="text-input"
                    />
                    <button type="submit">Crear</button>
                    {feedbackMessage && <p className={feedbackMessage.startsWith('Error') ? 'feedback-message error' : 'feedback-message success'}>{feedbackMessage}</p>}
                </form>
            </Modal>

            <Modal isOpen={isRenameModalOpen} onClose={closeRenameModal} title={`Renombrar "${itemToRename}"`}>
                <form onSubmit={onRenameSubmit} className="modal-form">
                    <input
                        type="text"
                        value={newItemName}
                        onChange={(e) => setNewItemName(e.target.value)}
                        placeholder="Nuevo nombre"
                        className="text-input"
                    />
                    <button type="submit">Renombrar</button>
                    {feedbackMessage && <p className={feedbackMessage.startsWith('Error') ? 'feedback-message error' : 'feedback-message success'}>{feedbackMessage}</p>}
                </form>
            </Modal>

            <Modal isOpen={isDeleteModalOpen} onClose={closeDeleteModal} title={`Eliminar "${itemToDelete}"`}>
                <div className="modal-body">
                    <p>¿Estás seguro de que quieres eliminar "<strong>{itemToDelete}</strong>"?</p>
                    {feedbackMessage && <p className={feedbackMessage.startsWith('Error') ? 'feedback-message error' : 'feedback-message success'}>{feedbackMessage}</p>}
                </div>
                <div className="modal-footer">
                    <button onClick={closeDeleteModal}>Cancelar</button>
                    <button onClick={onDeleteConfirm}>Sí, Eliminar</button>
                </div>
            </Modal>

            <ImagePreviewModal
                isOpen={isImagePreviewModalOpen}
                onClose={handleCloseImagePreviewModal}
                imageUrl={imageSrcToPreview}
            />
        </div>
    );
}

export default GestorDeArchivos;